import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private titleSubject = new BehaviorSubject<string>('Dashboard');
  public title$ = this.titleSubject.asObservable();

  /**
   * Set the header title
   * @param title - The title to display in the header
   */
  setTitle(title: string): void {
    this.titleSubject.next(title);
  }

  /**
   * Get the current header title as Observable
   */
  getTitle(): Observable<string> {
    return this.title$;
  }

  /**
   * Get the current header title value
   */
  getTitleValue(): string {
    return this.titleSubject.getValue();
  }
}
